import { OptionGroup } from "@/types/Search";
import apiFetch from "../token-guard/apiFetch";

export async function loadOptions(
  inputValue: string
): Promise<{ options: OptionGroup[]; hasMore: boolean }> {
  if (inputValue.length < 3) {
    return { options: [], hasMore: false };
  }
  const data = {
    starts_with: inputValue,
    limit: 10,
  };
  const encodedBody = Buffer.from(JSON.stringify(data)).toString("base64");
  try {
    const response = await apiFetch(`/api/search/hotel-search-destinations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encodedBody),
    });

    const data = await response;
    const transformedData: OptionGroup[] = Object.entries(data)
    .filter(([_, value]) => Array.isArray(value)).map(([key, value]) => ({
      category: key,
      options: (value as any[]).map(
        (item: {
          NAME: string;
          HOTEL_ID?: number;
          ID: number;
          COUNTRY_CODE: string;
          COUNTRY_NAME: string;
          IMAGE_350: string;
          NAME_SMALL_CAPS: string;
          CITY_NAME:string;
        }) => ({
          label: item.NAME,
          value: item.HOTEL_ID ?? item.ID,
          countryCode: item.COUNTRY_CODE,
          country: item.COUNTRY_NAME,
          isProperty: key === "property" ? true : false,
          IMAGE_350: key === "property" ? item.IMAGE_350 : "",
          city: key === "property" ? item.CITY_NAME : item.NAME_SMALL_CAPS,
          CITY_NAME: item.CITY_NAME,
          NAME_SMALL_CAPS: item.NAME_SMALL_CAPS,
        })
      ),
    }));

    return { options: transformedData, hasMore: false };
  } catch (error) {
    console.error("Error loading options:", error);
    return { options: [], hasMore: false };
  }
}
